import React, { useState } from 'react';
import { ArrowRightIcon, MenuIcon, XIcon, ZapIcon, SparklesIcon, TrendingUpIcon, CheckIcon } from 'lucide-react';
const Home4Page = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  return <div className="min-h-screen bg-gradient-to-b from-[#070a12] via-[#0b1020] to-[#070a12] text-[#e9eefc]" data-id="element-3412">
      {/* Gradient overlays */}
      <div className="fixed inset-0 pointer-events-none" data-id="element-3413">
        <div className="absolute top-0 right-[30%] w-[1100px] h-[700px] bg-[rgba(91,160,255,0.28)] rounded-full blur-[150px]" data-id="element-3414"></div>
        <div className="absolute top-[10%] left-[10%] w-[900px] h-[600px] bg-[rgba(152,96,255,0.22)] rounded-full blur-[140px]" data-id="element-3415"></div>
        <div className="absolute top-[55%] right-[10%] w-[900px] h-[700px] bg-[rgba(0,224,255,0.10)] rounded-full blur-[140px]" data-id="element-3416"></div>
      </div>

      {/* Header */}
      <header className="sticky top-0 z-50 bg-[rgba(7,10,18,0.72)] backdrop-blur-xl border-b border-[rgba(255,255,255,0.08)]" data-id="element-3417">
        <div className="max-w-[1120px] mx-auto px-5" data-id="element-3418">
          <nav className="flex items-center justify-between min-h-[74px]" data-id="element-3419">
            <a href="/" className="flex items-center gap-3 font-extrabold tracking-wide" data-id="element-3420">
              <div className="w-[34px] h-[34px] rounded-xl bg-gradient-to-br from-[#5ba0ff] to-[#8c5bff] shadow-[0_10px_30px_rgba(120,120,255,0.25)]" data-id="element-3421"></div>
              <span data-id="element-3422">Shopilots</span>
            </a>

            <div className="hidden md:flex items-center gap-5" data-id="element-3423">
              <a href="#platform" className="text-[#a9b4d6] font-semibold hover:text-[#e9eefc] transition-colors" data-id="element-3424">
                Platform
              </a>
              <a href="#solutions" className="text-[#a9b4d6] font-semibold hover:text-[#e9eefc] transition-colors" data-id="element-3425">
                Solutions
              </a>
              <a href="#customers" className="text-[#a9b4d6] font-semibold hover:text-[#e9eefc] transition-colors" data-id="element-3426">
                Customers
              </a>
              <a href="#pricing" className="text-[#a9b4d6] font-semibold hover:text-[#e9eefc] transition-colors" data-id="element-3427">
                Pricing
              </a>
            </div>

            <div className="flex items-center gap-3" data-id="element-3428">
              <a href="mailto:info@shopilots.com" className="hidden md:inline-flex items-center gap-2 px-4 py-3 rounded-xl border border-[rgba(255,255,255,0.10)] bg-transparent text-[#e9eefc] font-semibold hover:border-[rgba(255,255,255,0.18)] hover:bg-[rgba(255,255,255,0.09)] transition-all" data-id="element-3429">
                Contact
              </a>
              <a href="https://chat.shopilots.com/signup?product=shopilots" className="inline-flex items-center gap-2 px-4 py-3 rounded-xl bg-gradient-to-br from-[#5ba0ff] to-[#8c5bff] text-white font-semibold hover:from-[#6ab1ff] hover:to-[#9a6cff] transition-all shadow-lg" data-id="element-3430">
                Get started
              </a>
              <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden w-[42px] h-[42px] rounded-xl border border-[rgba(255,255,255,0.10)] bg-[rgba(255,255,255,0.05)] flex items-center justify-center" data-id="element-3431">
                {isMobileMenuOpen ? <XIcon className="w-5 h-5" data-id="element-3432" /> : <MenuIcon className="w-5 h-5" data-id="element-3433" />}
              </button>
            </div>
          </nav>

          {/* Mobile menu */}
          {isMobileMenuOpen && <div className="md:hidden border-t border-[rgba(255,255,255,0.08)]" data-id="element-3434">
              <a href="#platform" className="block px-5 py-4 text-[#a9b4d6] font-bold border-b border-[rgba(255,255,255,0.06)]" data-id="element-3435">
                Platform
              </a>
              <a href="#solutions" className="block px-5 py-4 text-[#a9b4d6] font-bold border-b border-[rgba(255,255,255,0.06)]" data-id="element-3436">
                Solutions
              </a>
              <a href="#customers" className="block px-5 py-4 text-[#a9b4d6] font-bold border-b border-[rgba(255,255,255,0.06)]" data-id="element-3437">
                Customers
              </a>
              <a href="#pricing" className="block px-5 py-4 text-[#a9b4d6] font-bold border-b border-[rgba(255,255,255,0.06)]" data-id="element-3438">
                Pricing
              </a>
              <a href="mailto:info@shopilots.com" className="block px-5 py-4 text-[#a9b4d6] font-bold" data-id="element-3439">
                Contact
              </a>
            </div>}
        </div>
      </header>

      <main className="relative z-10" data-id="element-3440">
        {/* Hero Section */}
        <section className="py-9 px-5" data-id="element-3441">
          <div className="max-w-[1120px] mx-auto" data-id="element-3442">
            <div className="grid lg:grid-cols-2 gap-5" data-id="element-3443">
              {/* Hero Left */}
              <div className="border border-[rgba(255,255,255,0.10)] bg-gradient-to-b from-[rgba(255,255,255,0.05)] to-[rgba(255,255,255,0.02)] rounded-[18px] p-7 shadow-[0_20px_60px_rgba(0,0,0,0.45)]" data-id="element-3444">
                <div className="inline-flex items-center gap-2 px-3 py-2 border border-[rgba(255,255,255,0.10)] rounded-full bg-[rgba(255,255,255,0.05)] text-[#a9b4d6] font-semibold text-sm mb-4" data-id="element-3445">
                  <div className="w-2 h-2 rounded-full bg-gradient-to-br from-[#5ba0ff] to-[#8c5bff]" data-id="element-3446"></div>
                  AI-powered growth for modern commerce
                </div>

                <h1 className="text-5xl md:text-6xl font-bold leading-tight tracking-tight mb-4" data-id="element-3447">
                  World-class AI-powered eCommerce & digital experiences
                </h1>

                <p className="text-lg text-[#a9b4d6] mb-5 leading-relaxed" data-id="element-3448">
                  Shopilots helps teams build, personalize, test, and optimize
                  storefront experiences that convert—without slowing down
                  product or marketing.
                </p>

                <div className="flex flex-wrap gap-3 mb-5" data-id="element-3449">
                  <a href="https://calendar.app.google/7twCNBfwZBuVCKbk7" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-4 py-3 rounded-xl bg-gradient-to-br from-[#5ba0ff] to-[#8c5bff] text-white font-semibold hover:from-[#6ab1ff] hover:to-[#9a6cff] transition-all" data-id="element-3450">
                    Book a demo
                  </a>
                  <a href="#platform" className="inline-flex items-center gap-2 px-4 py-3 rounded-xl border border-[rgba(255,255,255,0.10)] bg-[rgba(255,255,255,0.06)] text-[#e9eefc] font-semibold hover:border-[rgba(255,255,255,0.18)] hover:bg-[rgba(255,255,255,0.09)] transition-all" data-id="element-3451">
                    Explore the platform
                  </a>
                </div>

                <div className="flex flex-wrap gap-5 text-[#a9b4d6] font-semibold text-sm" data-id="element-3452">
                  <span className="flex items-center gap-2" data-id="element-3453">
                    <div className="w-2 h-2 rounded-full bg-gradient-to-br from-[#5ba0ff] to-[#8c5bff]" data-id="element-3454"></div>
                    Fast experimentation
                  </span>
                  <span className="flex items-center gap-2" data-id="element-3455">
                    <div className="w-2 h-2 rounded-full bg-gradient-to-br from-[#5ba0ff] to-[#8c5bff]" data-id="element-3456"></div>
                    AI personalization
                  </span>
                  <span className="flex items-center gap-2" data-id="element-3457">
                    <div className="w-2 h-2 rounded-full bg-gradient-to-br from-[#5ba0ff] to-[#8c5bff]" data-id="element-3458"></div>
                    Measurable impact
                  </span>
                </div>
              </div>

              {/* Hero Right */}
              <div className="border border-[rgba(255,255,255,0.10)] bg-gradient-to-b from-[rgba(255,255,255,0.05)] to-[rgba(255,255,255,0.02)] rounded-[18px] p-7 shadow-[0_20px_60px_rgba(0,0,0,0.45)] relative overflow-hidden" data-id="element-3459">
                <div className="border border-[rgba(255,255,255,0.10)] rounded-2xl min-h-[280px] flex items-center justify-center relative overflow-hidden" style={{
                background: `
                      radial-gradient(700px 280px at 20% 30%, rgba(91,160,255,0.35), transparent 55%),
                      radial-gradient(500px 260px at 70% 20%, rgba(152,96,255,0.30), transparent 55%),
                      linear-gradient(180deg, rgba(255,255,255,0.05), rgba(255,255,255,0.02))
                    `
              }} data-id="element-3460">
                  <div className="grid grid-cols-2 gap-3 w-full max-w-[520px] p-5" data-id="element-3461">
                    <div className="p-4 rounded-xl border border-[rgba(255,255,255,0.10)] bg-[rgba(12,18,35,0.65)] backdrop-blur-sm" data-id="element-3462">
                      <div className="text-3xl font-extrabold tracking-tight" data-id="element-3463">
                        +18%
                      </div>
                      <div className="text-[#a9b4d6] font-semibold text-xs mt-1" data-id="element-3464">
                        Conversion uplift
                      </div>
                    </div>
                    <div className="p-4 rounded-xl border border-[rgba(255,255,255,0.10)] bg-[rgba(12,18,35,0.65)] backdrop-blur-sm" data-id="element-3465">
                      <div className="text-3xl font-extrabold tracking-tight" data-id="element-3466">
                        -32%
                      </div>
                      <div className="text-[#a9b4d6] font-semibold text-xs mt-1" data-id="element-3467">
                        Time to launch
                      </div>
                    </div>
                    <div className="p-4 rounded-xl border border-[rgba(255,255,255,0.10)] bg-[rgba(12,18,35,0.65)] backdrop-blur-sm" data-id="element-3468">
                      <div className="text-3xl font-extrabold tracking-tight" data-id="element-3469">
                        2.4x
                      </div>
                      <div className="text-[#a9b4d6] font-semibold text-xs mt-1" data-id="element-3470">
                        Experiment velocity
                      </div>
                    </div>
                    <div className="p-4 rounded-xl border border-[rgba(255,255,255,0.10)] bg-[rgba(12,18,35,0.65)] backdrop-blur-sm" data-id="element-3471">
                      <div className="text-3xl font-extrabold tracking-tight" data-id="element-3472">
                        +21%
                      </div>
                      <div className="text-[#a9b4d6] font-semibold text-xs mt-1" data-id="element-3473">
                        AOV improvement
                      </div>
                    </div>
                  </div>
                </div>
                <div className="text-[#a9b4d6] text-sm mt-3" data-id="element-3474">
                  Real results from Shopilots customers
                </div>
              </div>
            </div>

            {/* Trusted strip */}
            <div className="mt-5" data-id="element-3475">
              <div className="flex flex-wrap gap-4 items-center justify-between border border-[rgba(255,255,255,0.10)] bg-[rgba(255,255,255,0.03)] rounded-[18px] p-4" data-id="element-3476">
                <div className="text-[#a9b4d6] font-bold text-sm" data-id="element-3477">
                  Trusted by teams scaling online revenue
                </div>
                <div className="flex flex-wrap gap-3" data-id="element-3478">
                  <div className="px-3 py-2 border border-dashed border-[rgba(255,255,255,0.14)] rounded-full text-[#a9b4d6] font-bold text-sm" data-id="element-3479">
                    Retail
                  </div>
                  <div className="px-3 py-2 border border-dashed border-[rgba(255,255,255,0.14)] rounded-full text-[#a9b4d6] font-bold text-sm" data-id="element-3480">
                    DTC
                  </div>
                  <div className="px-3 py-2 border border-dashed border-[rgba(255,255,255,0.14)] rounded-full text-[#a9b4d6] font-bold text-sm" data-id="element-3481">
                    SaaS
                  </div>
                  <div className="px-3 py-2 border border-dashed border-[rgba(255,255,255,0.14)] rounded-full text-[#a9b4d6] font-bold text-sm" data-id="element-3482">
                    Enterprise
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[rgba(255,255,255,0.14)] to-transparent" data-id="element-3483"></div>

        {/* Three Features Section */}
        <section id="platform" className="py-20 px-5" data-id="element-3484">
          <div className="max-w-[1120px] mx-auto" data-id="element-3485">
            <div className="border border-[rgba(255,255,255,0.10)] bg-gradient-to-b from-[rgba(255,255,255,0.05)] to-[rgba(255,255,255,0.02)] rounded-[18px] p-6 shadow-[0_20px_60px_rgba(0,0,0,0.45)]" data-id="element-3486">
              <div className="grid lg:grid-cols-2 gap-4 items-center mb-5" data-id="element-3487">
                <div data-id="element-3488">
                  <h2 className="text-4xl font-bold leading-tight tracking-tight" data-id="element-3489">
                    Test, personalize, and analyze: good things come in threes
                  </h2>
                  <div className="text-[#a9b4d6] text-sm mt-2" data-id="element-3490">
                    Create meaningful 1:1 interactions, every time
                  </div>
                </div>
                <div data-id="element-3491">
                  <p className="text-[#a9b4d6] text-lg mb-4" data-id="element-3492">
                    Combine rapid experimentation, AI-driven personalization,
                    and clean performance analytics to turn ideas into
                    measurable business outcomes.
                  </p>
                  <a href="#solutions" className="inline-flex items-center gap-2 text-[#e9eefc] font-bold" data-id="element-3493">
                    Optimize with Shopilots
                    <span className="w-5 h-5 rounded-md bg-[rgba(255,255,255,0.06)] border border-[rgba(255,255,255,0.12)] flex items-center justify-center text-sm" data-id="element-3494">
                      →
                    </span>
                  </a>
                </div>
              </div>

              <div className="grid md:grid-cols-3 gap-4" data-id="element-3495">
                <div className="border border-[rgba(255,255,255,0.10)] bg-gradient-to-b from-[rgba(255,255,255,0.05)] to-[rgba(255,255,255,0.02)] rounded-[18px] p-4 shadow-[0_20px_60px_rgba(0,0,0,0.45)]" data-id="element-3496">
                  <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[rgba(91,160,255,0.35)] to-[rgba(152,96,255,0.30)] border border-[rgba(255,255,255,0.12)] flex items-center justify-center text-2xl" data-id="element-3497">
                    ⚡
                  </div>
                  <h3 className="text-xl font-bold mt-3 mb-2" data-id="element-3498">
                    Experimentation
                  </h3>
                  <p className="text-[#a9b4d6]" data-id="element-3499">
                    Launch A/B and multivariate tests across PDP, collection,
                    cart, and checkout flows—safely and quickly.
                  </p>
                </div>

                <div className="border border-[rgba(255,255,255,0.10)] bg-gradient-to-b from-[rgba(255,255,255,0.05)] to-[rgba(255,255,255,0.02)] rounded-[18px] p-4 shadow-[0_20px_60px_rgba(0,0,0,0.45)]" data-id="element-3500">
                  <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[rgba(91,160,255,0.35)] to-[rgba(152,96,255,0.30)] border border-[rgba(255,255,255,0.12)] flex items-center justify-center text-2xl" data-id="element-3501">
                    ✨
                  </div>
                  <h3 className="text-xl font-bold mt-3 mb-2" data-id="element-3502">
                    Personalization
                  </h3>
                  <p className="text-[#a9b4d6]" data-id="element-3503">
                    Use AI segments, recommendations, and dynamic content to
                    match intent and context—automatically.
                  </p>
                </div>

                <div className="border border-[rgba(255,255,255,0.10)] bg-gradient-to-b from-[rgba(255,255,255,0.05)] to-[rgba(255,255,255,0.02)] rounded-[18px] p-4 shadow-[0_20px_60px_rgba(0,0,0,0.45)]" data-id="element-3504">
                  <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[rgba(91,160,255,0.35)] to-[rgba(152,96,255,0.30)] border border-[rgba(255,255,255,0.12)] flex items-center justify-center text-2xl" data-id="element-3505">
                    📈
                  </div>
                  <h3 className="text-xl font-bold mt-3 mb-2" data-id="element-3506">Analytics</h3>
                  <p className="text-[#a9b4d6]" data-id="element-3507">
                    Understand lift, revenue impact, and customer behavior with
                    clear dashboards built for growth teams.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Solutions Blocks */}
        <section id="solutions" className="py-20 px-5" data-id="element-3508">
          <div className="max-w-[1120px] mx-auto" data-id="element-3509">
            <div className="grid lg:grid-cols-2 gap-5" data-id="element-3510">
              <div className="border border-[rgba(255,255,255,0.10)] bg-gradient-to-b from-[rgba(255,255,255,0.05)] to-[rgba(255,255,255,0.02)] rounded-[18px] p-5 shadow-[0_20px_60px_rgba(0,0,0,0.45)] relative overflow-hidden" data-id="element-3511">
                <div className="absolute inset-[-2px] pointer-events-none" style={{
                background: `
                      radial-gradient(520px 220px at 20% 20%, rgba(91,160,255,0.18), transparent 55%),
                      radial-gradient(520px 240px at 80% 0%, rgba(152,96,255,0.16), transparent 60%)
                    `
              }} data-id="element-3512"></div>
                <div className="relative" data-id="element-3513">
                  <h2 className="text-4xl font-bold leading-tight tracking-tight mb-3" data-id="element-3514">
                    Build experiences that move revenue
                  </h2>
                  <p className="text-[#a9b4d6] text-sm mb-4" data-id="element-3515">
                    A workflow designed for marketers, product, and
                    engineering—no bottlenecks.
                  </p>

                  <ul className="space-y-3 mb-4" data-id="element-3516">
                    <li className="flex gap-3 text-[#a9b4d6] font-semibold" data-id="element-3517">
                      <span className="w-5 h-5 rounded-md bg-[rgba(91,160,255,0.18)] border border-[rgba(91,160,255,0.35)] flex items-center justify-center flex-shrink-0 text-sm" data-id="element-3518">
                        ✓
                      </span>
                      Visual editor + reusable components
                    </li>
                    <li className="flex gap-3 text-[#a9b4d6] font-semibold" data-id="element-3519">
                      <span className="w-5 h-5 rounded-md bg-[rgba(91,160,255,0.18)] border border-[rgba(91,160,255,0.35)] flex items-center justify-center flex-shrink-0 text-sm" data-id="element-3520">
                        ✓
                      </span>
                      Guardrails, targeting, and approvals
                    </li>
                    <li className="flex gap-3 text-[#a9b4d6] font-semibold" data-id="element-3521">
                      <span className="w-5 h-5 rounded-md bg-[rgba(91,160,255,0.18)] border border-[rgba(91,160,255,0.35)] flex items-center justify-center flex-shrink-0 text-sm" data-id="element-3522">
                        ✓
                      </span>
                      Performance-friendly delivery
                    </li>
                  </ul>

                  <div className="flex flex-wrap gap-3" data-id="element-3523">
                    <a href="mailto:info@shopilots.com" className="inline-flex items-center gap-2 px-4 py-3 rounded-xl bg-gradient-to-br from-[#5ba0ff] to-[#8c5bff] text-white font-semibold hover:from-[#6ab1ff] hover:to-[#9a6cff] transition-all" data-id="element-3524">
                      Talk to sales
                    </a>
                    <a href="#customers" className="inline-flex items-center gap-2 px-4 py-3 rounded-xl border border-[rgba(255,255,255,0.10)] bg-[rgba(255,255,255,0.06)] text-[#e9eefc] font-semibold hover:border-[rgba(255,255,255,0.18)] hover:bg-[rgba(255,255,255,0.09)] transition-all" data-id="element-3525">
                      See customer stories
                    </a>
                  </div>
                </div>
              </div>

              <div id="pricing" className="border border-[rgba(255,255,255,0.10)] bg-gradient-to-b from-[rgba(255,255,255,0.05)] to-[rgba(255,255,255,0.02)] rounded-[18px] p-5 shadow-[0_20px_60px_rgba(0,0,0,0.45)] relative overflow-hidden" data-id="element-3526">
                <div className="absolute inset-[-2px] pointer-events-none" style={{
                background: `
                      radial-gradient(520px 220px at 20% 20%, rgba(91,160,255,0.18), transparent 55%),
                      radial-gradient(520px 240px at 80% 0%, rgba(152,96,255,0.16), transparent 60%)
                    `
              }} data-id="element-3527"></div>
                <div className="relative" data-id="element-3528">
                  <h2 className="text-4xl font-bold leading-tight tracking-tight mb-3" data-id="element-3529">
                    Scale from quick wins to enterprise programs
                  </h2>
                  <p className="text-[#a9b4d6] text-sm mb-4" data-id="element-3530">
                    Start small, prove impact, then expand experimentation and
                    personalization across your store.
                  </p>

                  <ul className="space-y-3 mb-4" data-id="element-3531">
                    <li className="flex gap-3 text-[#a9b4d6] font-semibold" data-id="element-3532">
                      <span className="w-5 h-5 rounded-md bg-[rgba(91,160,255,0.18)] border border-[rgba(91,160,255,0.35)] flex items-center justify-center flex-shrink-0 text-sm" data-id="element-3533">
                        ✓
                      </span>
                      Starter: $39/mo - Core tests + reporting
                    </li>
                    <li className="flex gap-3 text-[#a9b4d6] font-semibold" data-id="element-3534">
                      <span className="w-5 h-5 rounded-md bg-[rgba(91,160,255,0.18)] border border-[rgba(91,160,255,0.35)] flex items-center justify-center flex-shrink-0 text-sm" data-id="element-3535">
                        ✓
                      </span>
                      Growth: $99/mo - AI personalization + automation
                    </li>
                    <li className="flex gap-3 text-[#a9b4d6] font-semibold" data-id="element-3536">
                      <span className="w-5 h-5 rounded-md bg-[rgba(91,160,255,0.18)] border border-[rgba(91,160,255,0.35)] flex items-center justify-center flex-shrink-0 text-sm" data-id="element-3537">
                        ✓
                      </span>
                      Enterprise: Custom - Governance + advanced controls
                    </li>
                  </ul>

                  <a href="/pricing" className="inline-flex items-center gap-2 text-[#e9eefc] font-bold" data-id="element-3538">
                    View full pricing
                    <span className="w-5 h-5 rounded-md bg-[rgba(255,255,255,0.06)] border border-[rgba(255,255,255,0.12)] flex items-center justify-center text-sm" data-id="element-3539">
                      →
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonial + CTA */}
        <section id="customers" className="py-20 px-5" data-id="element-3540">
          <div className="max-w-[1120px] mx-auto" data-id="element-3541">
            <div className="grid lg:grid-cols-[1.1fr_0.9fr] gap-5" data-id="element-3542">
              <div className="border border-[rgba(255,255,255,0.10)] bg-gradient-to-b from-[rgba(255,255,255,0.05)] to-[rgba(255,255,255,0.02)] rounded-[18px] p-6 shadow-[0_20px_60px_rgba(0,0,0,0.45)]" data-id="element-3543">
                <div className="inline-flex items-center gap-2 px-3 py-2 border border-[rgba(255,255,255,0.10)] rounded-full bg-[rgba(255,255,255,0.05)] text-[#a9b4d6] font-semibold text-sm mb-3" data-id="element-3544">
                  <div className="w-2 h-2 rounded-full bg-gradient-to-br from-[#5ba0ff] to-[#8c5bff]" data-id="element-3545"></div>
                  Customer outcome
                </div>
                <h2 className="text-4xl font-bold leading-tight tracking-tight mb-3" data-id="element-3546">
                  "Shopilots helped us ship faster and lift conversion—without
                  extra engineering cycles."
                </h2>
                <p className="text-[#a9b4d6] text-lg" data-id="element-3547">
                  From new landing pages to cart optimizations, our team tested
                  more ideas per month and made decisions with confidence.
                </p>
                <div className="flex items-center gap-3 mt-4" data-id="element-3548">
                  <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#5ba0ff] to-[#8c5bff] opacity-90" data-id="element-3549"></div>
                  <div data-id="element-3550">
                    <div className="font-extrabold" data-id="element-3551">Growth Lead</div>
                    <div className="text-[#a9b4d6] text-sm" data-id="element-3552">
                      Mid-market eCommerce brand
                    </div>
                  </div>
                </div>
              </div>

              <div className="border border-[rgba(255,255,255,0.10)] bg-gradient-to-b from-[rgba(255,255,255,0.05)] to-[rgba(255,255,255,0.02)] rounded-[18px] p-6 shadow-[0_20px_60px_rgba(0,0,0,0.45)]" data-id="element-3553">
                <h3 className="text-xl font-bold mb-3" data-id="element-3554">
                  What you'll get on the demo
                </h3>
                <ul className="space-y-3 mb-4" data-id="element-3555">
                  <li className="flex gap-3 text-[#a9b4d6] font-semibold" data-id="element-3556">
                    <span className="w-5 h-5 rounded-md bg-[rgba(91,160,255,0.18)] border border-[rgba(91,160,255,0.35)] flex items-center justify-center flex-shrink-0 text-sm" data-id="element-3557">
                      ✓
                    </span>
                    A store audit + quick-win test ideas
                  </li>
                  <li className="flex gap-3 text-[#a9b4d6] font-semibold" data-id="element-3558">
                    <span className="w-5 h-5 rounded-md bg-[rgba(91,160,255,0.18)] border border-[rgba(91,160,255,0.35)] flex items-center justify-center flex-shrink-0 text-sm" data-id="element-3559">
                      ✓
                    </span>
                    Personalization examples for your catalog
                  </li>
                  <li className="flex gap-3 text-[#a9b4d6] font-semibold" data-id="element-3560">
                    <span className="w-5 h-5 rounded-md bg-[rgba(91,160,255,0.18)] border border-[rgba(91,160,255,0.35)] flex items-center justify-center flex-shrink-0 text-sm" data-id="element-3561">
                      ✓
                    </span>
                    Measurement plan tied to revenue KPIs
                  </li>
                </ul>
                <a href="https://calendar.app.google/7twCNBfwZBuVCKbk7" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-4 py-3 rounded-xl bg-gradient-to-br from-[#5ba0ff] to-[#8c5bff] text-white font-semibold hover:from-[#6ab1ff] hover:to-[#9a6cff] transition-all" data-id="element-3562">
                  Book a demo
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Final CTA */}
        <section className="py-20 px-5" data-id="element-3563">
          <div className="max-w-[1120px] mx-auto" data-id="element-3564">
            <div className="border border-[rgba(255,255,255,0.10)] bg-gradient-to-b from-[rgba(255,255,255,0.05)] to-[rgba(255,255,255,0.02)] rounded-[18px] p-6 shadow-[0_20px_60px_rgba(0,0,0,0.45)] text-center" data-id="element-3565">
              <div className="inline-flex items-center gap-2 px-3 py-2 border border-[rgba(255,255,255,0.10)] rounded-full bg-[rgba(255,255,255,0.05)] text-[#a9b4d6] font-semibold text-sm mb-3" data-id="element-3566">
                <div className="w-2 h-2 rounded-full bg-gradient-to-br from-[#5ba0ff] to-[#8c5bff]" data-id="element-3567"></div>
                Ready to grow?
              </div>
              <h2 className="text-4xl font-bold leading-tight tracking-tight mb-3" data-id="element-3568">
                Launch your next optimization program with Shopilots
              </h2>
              <p className="text-[#a9b4d6] text-lg max-w-2xl mx-auto mb-4" data-id="element-3569">
                Turn ideas into experiments, personalize experiences with AI,
                and prove impact with clean analytics—on one platform.
              </p>
              <div className="flex flex-wrap gap-3 justify-center" data-id="element-3570">
                <a href="mailto:info@shopilots.com" className="inline-flex items-center gap-2 px-4 py-3 rounded-xl bg-gradient-to-br from-[#5ba0ff] to-[#8c5bff] text-white font-semibold hover:from-[#6ab1ff] hover:to-[#9a6cff] transition-all" data-id="element-3571">
                  Email us
                </a>
                <a href="#platform" className="inline-flex items-center gap-2 px-4 py-3 rounded-xl border border-[rgba(255,255,255,0.10)] bg-[rgba(255,255,255,0.06)] text-[#e9eefc] font-semibold hover:border-[rgba(255,255,255,0.18)] hover:bg-[rgba(255,255,255,0.09)] transition-all" data-id="element-3572">
                  Back to platform
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="py-14 px-5 text-[#a9b4d6]" data-id="element-3573">
          <div className="max-w-[1120px] mx-auto" data-id="element-3574">
            <div className="grid md:grid-cols-4 gap-5 mb-5" data-id="element-3575">
              <div data-id="element-3576">
                <div className="flex items-center gap-3 font-extrabold text-[#e9eefc] mb-3" data-id="element-3577">
                  <div className="w-[34px] h-[34px] rounded-xl bg-gradient-to-br from-[#5ba0ff] to-[#8c5bff]" data-id="element-3578"></div>
                  <span data-id="element-3579">Shopilots</span>
                </div>
                <div className="text-sm" data-id="element-3580">
                  AI-powered eCommerce experimentation, personalization, and
                  analytics.
                </div>
              </div>
              <div data-id="element-3581">
                <div className="font-extrabold text-[#e9eefc] mb-3" data-id="element-3582">
                  Product
                </div>
                <div className="space-y-2 text-sm" data-id="element-3583">
                  <a href="#platform" className="block hover:text-[#e9eefc]" data-id="element-3584">
                    Platform
                  </a>
                  <a href="#solutions" className="block hover:text-[#e9eefc]" data-id="element-3585">
                    Solutions
                  </a>
                  <a href="#pricing" className="block hover:text-[#e9eefc]" data-id="element-3586">
                    Pricing
                  </a>
                </div>
              </div>
              <div data-id="element-3587">
                <div className="font-extrabold text-[#e9eefc] mb-3" data-id="element-3588">
                  Company
                </div>
                <div className="space-y-2 text-sm" data-id="element-3589">
                  <a href="/blog" className="block hover:text-[#e9eefc]" data-id="element-3590">
                    Blog
                  </a>
                  <a href="/case_studies" className="block hover:text-[#e9eefc]" data-id="element-3591">
                    Case Studies
                  </a>
                  <a href="mailto:info@shopilots.com" className="block hover:text-[#e9eefc]" data-id="element-3592">
                    Contact
                  </a>
                </div>
              </div>
              <div data-id="element-3593">
                <div className="font-extrabold text-[#e9eefc] mb-3" data-id="element-3594">
                  Resources
                </div>
                <div className="space-y-2 text-sm" data-id="element-3595">
                  <a href="#customers" className="block hover:text-[#e9eefc]" data-id="element-3596">
                    Customers
                  </a>
                  <a href="https://calendar.app.google/7twCNBfwZBuVCKbk7" target="_blank" rel="noopener noreferrer" className="block hover:text-[#e9eefc]" data-id="element-3597">
                    Demo
                  </a>
                  <a href="/pricing" className="block hover:text-[#e9eefc]" data-id="element-3598">
                    Pricing Details
                  </a>
                </div>
              </div>
            </div>
            <div className="flex flex-wrap gap-3 items-center justify-between pt-4 border-t border-[rgba(255,255,255,0.08)] text-sm" data-id="element-3599">
              <div data-id="element-3600">
                © {new Date().getFullYear()} Shopilots. All rights reserved.
              </div>
              <div className="flex gap-3" data-id="element-3601">
                <a href="#" className="hover:text-[#e9eefc]" data-id="element-3602">
                  Privacy
                </a>
                <a href="#" className="hover:text-[#e9eefc]" data-id="element-3603">
                  Terms
                </a>
              </div>
            </div>
          </div>
        </footer>
      </main>
    </div>;
};
export default Home4Page;